import { Card, Modal } from 'antd'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import CustomTable from '../../../elements/Table/CustomTable'
import React from 'react'
import { get } from 'lodash'
import { Link } from 'react-router-dom'

function CashflowModal(props) {
  const { visible, onCancel, modalData, fetching, fetch } = props

  const data = get(modalData, `${modalData.acc}.data`)

  const columns = [
    {
      Header: 'Order',
      accessor: 'order.code',
      Cell: ({ original, value }) => {
        console.log({ original })
        const isWorkOrder = get(original, 'order.type') === 'Work Order'
        const isLoan = get(original, 'order.type') === 'Employee Debt'
        const disabled = isWorkOrder || isLoan
        let to = `/purchasing/Order/${get(original, 'order._id', '').replace('purchases/', '')}/update`
        return disabled ? (
          value
        ) : (
          <Link to={to} style={{ marginLeft: '10px' }} target={'_blank'}>
            {value}
          </Link>
        )
      },
    },
    { Header: 'Company', accessor: 'order.company.fn', hideable: true, hideDefault: true },
    { Header: 'Vendor', accessor: 'order.vendor.fn', hideable: true, hideDefault: true },
    { Header: 'Title', accessor: 'order.title' },
    { Header: 'Type', accessor: 'order.type' },
    { Header: 'Amount', accessor: 'amount', Cell: MoneyCell },
  ]
  console.log({ data })
  return (
    <Modal
      fetch={fetch}
      fetching={fetching}
      visible={visible}
      title={`${modalData.title} in ${modalData.date} - ${modalData.currency}`}
      onCancel={onCancel}
      destroyOnClose={true}
      width={'75%'}>
      <CustomTable
        columns={columns}
        data={data}
        show={{
          csv: {
            fileName: `${modalData.title} in ${modalData.date} - ${modalData.currency}`,
          },
        }}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
      />
    </Modal>
  )
}

export default CashflowModal
